import React from 'react';
import { MailIcon } from 'lucide-react';
import { contactEmail } from '../data/content';
export function ContactSection() {
  return <section className="border-b border-line bg-panel py-16 sm:py-20" data-id="element-54" data-mp="2za4ibr9qa85f">
      <div className="mx-auto flex max-w-4xl flex-col gap-6 px-5 sm:flex-row sm:items-center sm:justify-between sm:px-8" data-id="element-55" data-mp="2kkf5uzw6qhpu">
        <div data-id="element-56" data-mp="2pj9wgo0e9aki">
          <p className="text-[11px] font-semibold uppercase tracking-[0.24em] text-acid" data-id="element-57" data-mp="2pj04wvzpavcp">
            Contact us
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold uppercase tracking-tight text-white sm:text-4xl" data-id="element-58" data-mp="3i7e2jamvnpnq">
            Questions before you buy?
          </h2>
          <p className="mt-3 max-w-xl text-sm leading-relaxed text-white/55" data-id="element-59" data-mp="347d3m0q6asaw">
            Write to us and we&rsquo;ll get back to you. We answer every message
            about access, content, and refunds.
          </p>
        </div>
        <a href={`mailto:${contactEmail}`} className="inline-flex shrink-0 items-center gap-3 border border-line bg-night px-5 py-4 font-display text-lg font-bold uppercase tracking-tight text-white transition-colors duration-150 ease-smooth hover:border-acid hover:text-acid focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-acid" data-id="element-60" data-mp="1wu309voewx2f">
          <MailIcon className="h-5 w-5 text-acid" aria-hidden="true" data-id="element-61" data-mp="gkqenkvp9arw" />
          {contactEmail}
        </a>
      </div>
    </section>;
}